import {register} from "swiper/element/bundle";
import {AfterViewInit, Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
  selector: 'app-swiper',
  templateUrl: './swiper.component.html',
  styleUrls: ['./swiper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SwiperComponent implements AfterViewInit {
  @Input()
  swiperId = '';
  @Input()
  paginationType = 'fraction'

  ngAfterViewInit(): void {
    register();

    const params = {
      injectStyles: [
        '.swiper-pagination-bullet {width: 8px !important;height: 8px !important;background: #eaeaea !important; opacity: 1 !important;}',
        '.swiper-pagination-bullet-active {width: 8px !important;height: 8px !important;background: #212121 !important;border: opacity: 1 !important;}',
        '.swiper-button-next, .swiper-button-prev {color: #f3f5f7 !important;}',
        '.swiper-pagination.swiper-pagination-hidden {opacity: .1}',
        '@media screen and (max-width: 599px) {.swiper-button-next, .swiper-button-prev {color: #f3f5f7 !important;opacity: .1;}}'
      ],
      autoplay: {
        delay: 30000
      },
      threshold: 30,
      grabCursor: true,
      pagination: {
        type: this.paginationType,
        clickable: true,
        hideOnClick: true,
      }
    };

    if (this.swiperId) {
      const container: any = document.getElementById(this.swiperId);
      if (container) {
        Object.assign(container, params);
        container.initialize();
      }
    } else {
      document.querySelectorAll('swiper-container')
        .forEach((container: any) => {
          Object.assign(container, params);
          container.initialize();
        })
    }
  }
}
